import React, { PropTypes } from "react";

import noScroll from "no-scroll";

import DataSource from "./DataSource";
import Fields from "./Fields";
import Filters from "./Filters";
import Details from "./Details";
import Schedule from "./Schedule";
import Summary from "./Summary";

import Layout from "./NewReportLayout";

import * as actions from '../actions';

//
// const NewReportContainer = styled.div`
//   overflow: auto;
//   display: ${props => (props.isOpen ? 'block' : 'none')};
//   position: fixed;
//   z-index: 100;
//   top: 0;
//   bottom: 0;
//   left: 0;
//   right: 0;
//   background-color: #f0f0f0;
// `;
//
// const CloseButton = styled.button`
//   position: absolute;
//   right: 20px;
//   top: 20px;
//
//   border: 0;
//   outline: none;
//   background: none;
// `;
//
// const Header = styled.div`
//   height: 60px;
//   background-color: ${props => props.theme.color.primary};
//   font-family: ${props => props.theme.font.bold};
//   font-size: ${props => props.theme.size[2]};
//   color: ${props => props.theme.color.white};
//
//   display: flex;
//   align-items: center;
//   justify-content: center;
// `;

const steps = [
  {
    label: "Data source",
    component: DataSource
  },
  {
    label: "Fields",
    component: Fields
  },
  {
    label: "Filters",
    component: Filters
  },
  {
    label: "Details",
    component: Details
  },
  {
    label: "Schedule",
    component: Schedule
  },
  {
    label: "Summary",
    component: Summary
  }
];

class NewReport extends React.Component {
  constructor(props) {
    super(props);

    const { businessReports, businessReport } = props;

    const defaultBusinessReport = businessReports[0];
    this.state = {
      currentStep: 0,
      visitedStep: 0,
      reportId: defaultBusinessReport.id,
      navigationComponent: {
        left: null,
        middle: null,
        right: null
      },
      businessReport: {
        value: '',
        label: ''
      }
    };
  }

  // TODO: businessReport change
  componentDidMount() {
    if (this.props.isOpen) {
      noScroll.on();
    }
  }

  componentWillUpdate(nextProps) {
    if (nextProps.isOpen !== this.props.isOpen) {
      if (nextProps.isOpen) {
        noScroll.on();
      } else {
        noScroll.off();
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.businessReport !== this.props.businessReport && nextProps.businessReport) {
      this.setState({
       businessReport: {
          value: nextProps.businessReport.value,
          label: nextProps.businessReport.name
        },
        reportId: nextProps.businessReport.value
      }); 
    }

    if(!this.props.isOpen && nextProps.isOpen &&
      nextProps.directStep > -1) {
      this.goToStep(nextProps.directStep, steps.length);
    }
  }

  componentWillUnmount() {
    noScroll.off();
  }

  fetchReportFields = () => {
    const { reportCategory = "business", actions } = this.props;
    actions.fetchReportFields(this.props.businessReport.value, reportCategory);
  };

  // setSource = ({country, costcenter}) => {
  //   const { setCountry, setCostcenter, setFilters } = this.props.actions;
  //   setCountry(country);
  //   setCostcenter(costcenter);
  // }

  goToStep = (currentStep, customVisitedStep) => {
    const visitedStep = (typeof(customVisitedStep) !== 'undefined')? customVisitedStep : Math.max(this.state.visitedStep, currentStep);
    this.setState({
      currentStep,
      visitedStep
    });
  };

  goNext = () => {
    console.log(this.state.currentStep);
    const currentStep = this.state.currentStep;
    switch(currentStep) {
      case 0:
        if(!this.props.isEditMode)
          this.fetchReportFields();
        break;
    }
    if (this.state.currentStep + 1 < steps.length) {
      this.goToStep(this.state.currentStep + 1);
    } else {
      this.saveReport();
      //console.log(this);
    }
  };

  saveReportFailed = () => {
    this.props.notify({
      type: "error",
      title: "Failed",
      message: "Report creation is failed."
    });
  }


  saveReport = () => {
    const {category, reportId, businessReportId} = this.props;
    const type = category === "business" ? "create" : "update";
    const params = Object.assign({}, this.props, {
      reportCategory: type === 'create' ? 'business' : category,
      reportId: type === 'create' ? businessReportId : reportId
    });

    this.props.actions.reportAction(type, params)
    .then((data) => {

      if(!data.value.success) {
        return this.saveReportFailed();
      }

      if (type === 'create')
      {
        this.props.postCreate();
        const {country, costcenter} = this.props;
        this.fetchReports(country, costcenter);        
      }        
      else
        this.props.postUpdate();
    });
  }

  fetchReports(countrycode, companycode) {
    const roleIdParam = sessionStorage.getItem('roleId') ? { roleId: sessionStorage.getItem('roleId') } : {};
    const fetchParam = Object.assign({}, roleIdParam, { countrycode }, { companycode });
    this.props.actions.fetchReports(fetchParam);
  };

  goPrevious = () => {
    this.goToStep(this.state.currentStep - 1);
  };

  setNavigation = component => {
    this.setState({
      navigationComponent: component
    });
  };

  render() {
    const { isOpen, close, category, isEditMode } = this.props;
    const {
      currentStep,
      visitedStep,
      navigationComponent,
      ...otherState
    } = this.state;

    const StepComponent = steps[currentStep].component;
    const headerTitle = (category === 'business')? 'Create my report': 'Update my report';

    const navigation = {
      goToStep: this.goToStep,
      goNext: this.goNext,
      goPrevious: this.goPrevious,
      currentStep,
      visitedStep
    };
    return (
      <Layout
        isOpen={isOpen}
        close={close}
        steps={steps}
        navigationComponent={navigationComponent}
        navigation={navigation}
        title={headerTitle}
      >
        <StepComponent
          navigation={navigation}
          setNavigation={this.setNavigation}
          category={category}
          isEditMode={isEditMode}
          {...otherState}

        />
      </Layout>
    );
  }
}

NewReport.propTypes = {
  isOpen: PropTypes.bool,
  close: PropTypes.func,
  costcenter: PropTypes.object,
  country: PropTypes.object,
  businessReports: PropTypes.array,
  businessReport: PropTypes.object,
  category: PropTypes.string,
  postCreate: PropTypes.func,
  postUpdate: PropTypes.func,
  directStep: PropTypes.number,
  notify: PropTypes.func,
};

export default NewReport;



// WEBPACK FOOTER //
// ./src/features/scheduling-reports/new-report/NewReport.js